import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFiles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      fill="#787887"
      d="M13.531 2.063c.25.25.469.718.469 1.062V11.5a1.5 1.5 0 0 1-1.5 1.5H10v1.5A1.5 1.5 0 0 1 8.5 16h-7A1.48 1.48 0 0 1 0 14.5v-10A1.5 1.5 0 0 1 1.5 3H4V1.5A1.5 1.5 0 0 1 5.5 0h5.375c.344 0 .813.219 1.063.469zM8.312 14.5c.094 0 .188-.062.188-.187V13h-3A1.48 1.48 0 0 1 4 11.5v-7H1.688c-.125 0-.188.094-.188.188v9.625q0 .187.188.187zm4-3c.094 0 .188-.062.188-.187V5H9.75A.72.72 0 0 1 9 4.25V1.5H5.688c-.125 0-.188.094-.188.188v9.625q0 .187.188.187zm.188-8v-.281c0-.063-.031-.094-.062-.125l-1.532-1.531c-.031-.032-.062-.063-.125-.063H10.5v2z"
    />
  </svg>
);
export default SvgFiles;
